import React from "react"
import { navigate, withPrefix } from "gatsby"
import "whatwg-fetch"
class RedirectIndex extends React.PureComponent {
  constructor(args) {
    super(args)
    if (typeof window !== "undefined") {
      window.fetch("https://extreme-ip-lookup.com/json/")
        .then(res => res.json())
        .then(response => {
          if (response.country === "Germany") {
            const homeUrl = withPrefix(`/de/`)
            navigate(homeUrl)
          } else {
            const homeUrl = withPrefix(`/en/`)
            navigate(homeUrl)
          }
        })
        .catch((data, status) => {
          console.log("Request failed")
        })
    }
  }

  render() {
    return <div />
  }
}

export default RedirectIndex
